module.exports = __webpack_public_path__ + "media/icons/book-4b7f63bd.svg";